
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { IPagination } from '@/types';
import {
  getCustomAddressList,
  addCustomAddress,
  editCustomAddress,
  delCustomAddress
} from '@/api/custom';
import DialogSetImport from '../staff/components/setImport.vue';
import { array } from 'js-md5';
import { pid } from 'process';
import { checkPermissionCompany } from '@/utils/permission';
import { Type } from '../../types/permissionType';

@Component({
  name: 'SettingTemplateAddress',
  components: {
    DialogSetImport
  }
})
export default class extends Vue {
  private formSearch = {
    name: ''
  };

  private tableData = [];
  private dialogAddressVisible = false;
  private formAddress: any = {
    id: '',
    name: '',
    priority: '0',
    type: 1
  };

  private listLoading = false;
  private isCheckboxAll = true
  private selectedAll = false
  private isIndeterminate = false
  private jumpToAutoAssignOrder = false
  private addressSelected:any = []

  // 页码处理
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private rules = {
    // 请输入1-20位字母、中文、数字、-、_、/组成的名称
    name: [
      {
        required: true,
        message: '请输入1-100位字母、中文、数字、-、_、/组成的名称',
        trigger: 'blur'
      },
      {
        min: 1,
        max: 100,
        message: '请输入1-100位字母、中文、数字、-、_、/组成的名称',
        trigger: 'blur'
      },
      {
        pattern: /[\u4e00-\u9fa5a-zA-Z0-9-_/]/,
        message: '请输入1-100位字母、中文、数字、-、_、/组成的名称',
        trigger: 'blur'
      }
    ],
    priority: [
      {
        required: true,
        message: '请输入0~9999范围内的数值',
        trigger: 'blur'
      },
      {
        pattern: /^(0|([1-9]\d{0,3}))$/,
        message: '请输入0~9999范围内的数值',
        trigger: 'blur'
      }
    ]
  };

  created() {
    this.getList();
    this.jumpToAutoAssignOrder = checkPermissionCompany(UserModule.getCompanyId, Type.GroupPushAddress);
  }

  // 列表获取
  private getList() {
    this.listLoading = true;
    var params:any = {};
    params.company_id = UserModule.getCompanyId;
    params.contain_sub = 1;
    params.address = this.formSearch.name;
    params.page = this.pagination.currentPage;
    params.size = this.pagination.pageSize;
    // params.pid = pid;(二三级地址公司id)
    getCustomAddressList(params)
      .then((res) => {
        const data = res.data;
        if (data) {
          this.tableData = data.list;
          this.pagination.total = parseInt(data.count);
        } else {
          this.tableData = [];
        }
        this.listLoading = false;
      })
      .catch((err) => {
        this.listLoading = false;
        let msg = err.msg;
      });
  }

  // 搜索
  private handleSearch() {
    this.pagination.currentPage = 1;
    this.getList();
  }

  // 清除
  private handleClear() {
    this.formSearch = {
      name: ''
    };
    this.handleSearch();
  }

  // 页码切换
  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getList();
  }
  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  private handleCheckAllChange(val:any) {
    if (val && this.tableData) {
      this.checkAll(this.tableData);
    }
    // this.addressSelected = val ? this.tableData : [];
    this.isIndeterminate = false;
  }

  private checkAll(list:any) {
    let _ = this;
    list.map(function(item:any) {
      _.addressSelected.push(item);
      if (item && item.child && item.child.length > 0) {
        _.checkAll(item.child);
      }
    });
  }

  private handleSelectionChange(value: any) {
    let checkedCount = value.length;
    this.selectedAll = checkedCount === this.tableData.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.tableData.length;
  }

  // 添加地址
  private addSubHandle(val:any) {
    this.dialogAddressVisible = true;
    this.formAddress.name = '';
    this.formAddress.id = val;
    this.formAddress.priority = '0';
    this.formAddress.type = 1;
  }

  // 编辑
  private editHandle(val:any) {
    this.dialogAddressVisible = true;
    this.formAddress.name = val.address;
    this.formAddress.id = val.id;
    this.formAddress.priority = val.sort;
    this.formAddress.type = 2;
  }

  // 删除
  private deleteDataHandle(val:any) {
    this.$confirm('确定删除这条数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          address_ids: JSON.stringify([val.id])
        };
        delCustomAddress(params)
          .then((res) => {
            this.showSuccessMsg('删除成功');
            this.getList();
          })
          .catch((err) => {
            this.listLoading = false;
            let msg = err.msg;
            this.showErrorMsg(msg);
          });
      })
      .catch(() => {
      });
  }

  // 保存 编辑地址
  private handelAddress() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        if (parseInt(this.formAddress.type) === 1) {
          this.save();
        } else {
          this.edit();
        }
      } else {
        return false;
      }
    });
  }

  private save() {
    var params:any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    params.pid = this.formAddress.id;
    params.address = this.formAddress.name;
    params.sort = this.formAddress.priority;
    addCustomAddress(params)
      .then((res) => {
        if (parseInt(this.formAddress.type) === 1) {
          this.showSuccessMsg('保存成功');
        } else {
          this.showSuccessMsg('编辑成功');
        }
        this.getList();
        this.dialogAddressVisible = false;
      })
      .catch((err) => {
        this.listLoading = false;
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }

  private edit() {
    var params:any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    params.address_id = this.formAddress.id;
    params.address = this.formAddress.name;
    params.sort = this.formAddress.priority;
    editCustomAddress(params)
      .then((res) => {
        this.showSuccessMsg('编辑成功');
        this.getList();
        this.dialogAddressVisible = false;
      })
      .catch((err) => {
        this.listLoading = false;
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }

  // 导入
  private setImportVisible = false
  private setImportTitle='导入地址'
  private importAddress() {
    this.setImportVisible = true;
  }
  closeImport(value: boolean) {
    this.pagination.currentPage = 1;
    this.getList();
    this.setImportVisible = value;
  }

  // 批量删除
  private groupDelete() {
    if (this.addressSelected && this.addressSelected.length === 0) {
      this.showErrorMsg('请选择地址');
      return;
    }
    this.$confirm('确定删除这条数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        let arr:any = [];
        this.addressSelected.map(function(item:any) {
          arr.push(item.id);
        });
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          address_ids: JSON.stringify(arr)
        };
        delCustomAddress(params)
          .then((res) => {
            this.showSuccessMsg('删除成功');
            this.getList();
          })
          .catch((err) => {
            this.listLoading = false;
            let msg = err.msg;
            this.showErrorMsg(msg);
          });
      })
      .catch(() => {
      });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
